import * as API from '../api'
export const FETCH_PROBABILITY = 'FETCH_PROBABILITY'
export const FETCHING_PROBABILITY = 'FETCHING_PROBABILITY'
export const FETCH_PROBABILITY_ERROR = 'FETCH_PROBABILITY_ERROR'
export const FETCH_PROBABILITIES = 'FETCH_PROBABILITIES'
export const FETCH_PROBABILITIESALL = 'FETCH_PROBABILITIESALL'
export const FETCHING_PROBABILITIES = 'FETCHING_PROBABILITIES'
export const FETCH_PROBABILITIES_ERROR = 'FETCH_PROBABILITIES_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_PROBABILITY = 'CHANGE_PROBABILITY'
export const DELETE_PROBABILITY = 'DELETE_PROBABILITY'
export const ADD_PROBABILITY = 'ADD_PROBABILITY'
export const EDIT_PROBABILITY = 'EDIT_PROBABILITY'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_PROBABILITY = 'NEW_FORM_PROBABILITY'
export const PROBABILITY_FORM_ERROR = 'PROBABILITY_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeProbability = probability => {
  return dispatch => {
    dispatch({ type: CHANGE_PROBABILITY, probability })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const handleProbabilityError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: PROBABILITY_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormProbability = probability => {
  return dispatch => {
    dispatch({ type: NEW_FORM_PROBABILITY })
  }
}

export const setProbabilityFormTouched = probability => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreProbability = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PROBABILITIES })
    return API.probabilities
      .restoreProbability(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_PROBABILITY, probability: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_PROBABILITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleProbabilityError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchProbabilitiesAll = () => {
  return dispatch => {
    API.probabilities.getProbabilitiesAll().then((res = {}) => {
      const { data } = res
      dispatch({ type: FETCH_PROBABILITIESALL, probabilities: data })
    })
  }
}

export const fetchProbabilities = options => {
  return dispatch => {
    dispatch({ type: FETCHING_PROBABILITIES })
    return API.probabilities
      .getProbabilities(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_PROBABILITIES,
          probabilities: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_PROBABILITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const deleteProbability = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PROBABILITIES })
    return API.probabilities
      .deleteProbability(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_PROBABILITY, probability: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_PROBABILITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addProbability = probability => {
  return dispatch => {
    dispatch({ type: FETCHING_PROBABILITIES })
    dispatch({ type: FETCHING_PROBABILITY })
    return API.probabilities
      .addProbability(probability)
      .then(({ data }) => {
        dispatch({ type: ADD_PROBABILITY, probability: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleProbabilityError(response, dispatch)
        dispatch({
          type: FETCH_PROBABILITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editProbability = probability => {
  return dispatch => {
    dispatch({ type: FETCHING_PROBABILITIES })
    dispatch({ type: FETCHING_PROBABILITY })
    return API.probabilities
      .editProbability(probability)
      .then(({ data }) => {
        dispatch({ type: EDIT_PROBABILITY, probability: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_PROBABILITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleProbabilityError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchProbability = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PROBABILITY, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.probabilities
      .getProbability(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_PROBABILITY, probability: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_PROBABILITY_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/probabilities.js